module.exports = __webpack_public_path__ + "static/media/ic_mentored_yellow.7278de6b.svg";